import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import Stack from '@mui/material/Stack';
import PropTypes from 'prop-types';

const ActionsBar = ({onClose, children}) => {
  return (
    <DialogActions sx={{justifyContent: 'space-between'}}>
      <Button variant="outlined" onClick={onClose}>
        Cancel
      </Button>

      {children && (
        <Stack
          direction="row"
          sx={{
            gap: 1,
            alignItems: 'center',
          }}
        >
          {children}
        </Stack>
      )}
    </DialogActions>
  );
};

ActionsBar.propTypes = {
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node,
};

export default ActionsBar;
